import React from 'react';
import {Link} from 'react-router-dom';
import {
    IconButton,
    Tooltip
} from 'material-ui';
import {
    canEditOrViewTranslation,
    showViewTranslationButton
} from '../../../components/permissions/permissions';
import EditIcon from 'material-ui-icons/Edit';
import ViewIcon from 'material-ui-icons/Visibility';

class StaffTranslationsTableItemActionEdit extends React.Component {

    render() {
        const {
            classes,
            staffMember,
            staffTranslation
        } = this.props;

        const EditButton = () => (
            <span className={classes.tableIconBtn}>
                <Link to={"/staff/" + staffMember.id + "/translations/" + staffTranslation.id + "/edit"}>
                    <Tooltip title="Edit Translation">
                        <IconButton className="smallIconButton editColor">
                            <EditIcon />
                        </IconButton>
                    </Tooltip>
                </Link>{' '}
            </span>
        )

        const ViewButton = showViewTranslationButton(() =>
            <span className={classes.tableIconBtn}>
                <Link to={"/staff/" + staffMember.id + "/translations/" + staffTranslation.id + "/view"}>
                    <Tooltip title="View Translation">
                        <IconButton className="smallIconButton viewColor">
                            <ViewIcon />
                        </IconButton>
                    </Tooltip>
                </Link>{' '}
            </span>
        )

        let EditOrViewTranslation = canEditOrViewTranslation(EditButton, ViewButton);

        return (
            <EditOrViewTranslation />
        )
    }
};

export default StaffTranslationsTableItemActionEdit;




// WEBPACK FOOTER //
// ./src/containers/staff/translations/StaffTranslationsTableItemActionEdit.jsx